// extracted by mini-css-extract-plugin
module.exports = {"custom__top":"ShipmentError_custom__top__wcpTm"};